// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16XrR","inner":"Footer_inner__1Upwp","nextIcon":"Footer_nextIcon__2JYFh","innerLeft":"Footer_innerLeft__2arrJ"};